/**
 * @copyright 2025 Cooltrax Pty Ltd. All rights reserved.
 */

/**
 * Which identity provider an Auth0 user id came from.
 *
 * The same person routinely has more than one profile — an Active Directory row and a
 * legacy Cooltrax one, sharing an email and username — so the provider is often the only
 * thing that tells two otherwise identical rows apart.
 */
export const getAuthProviderLabel = (uid: string): string => {
  // waad|Cooltrax|<azure object id> — include the connection name (the middle
  // segment) so the label lines up with what the Auth0 dashboard calls the
  // same user's connection.
  if (uid.startsWith('waad')) {
    const connection = uid.split('|')[1]
    return connection ? `Active Directory · ${connection}` : 'Active Directory'
  }
  if (uid.startsWith('auth0')) return 'Cooltrax'
  if (uid.startsWith('google-oauth2')) return 'Google'
  // Enterprise connections carry the connection name inside the id,
  // e.g. samlp|h-e-b|user@heb.com or oidc|insight-idp|auth0|123.
  if (uid.startsWith('samlp|') || uid.startsWith('oidc|')) return uid.split('|')[1] ?? ''
  return ''
}
